import axios from "axios";

const api = axios.create({
  baseURL: "https://acesso.cronosagenda.com.br/api",  // URL do backend no seu VPS
  withCredentials: true,  // Permite o envio de cookies e credenciais
});

export default api;
